import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CookieSettings } from './CookieSettings';
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [showCookieSettings, setShowCookieSettings] = useState(false);
  const handleCookieSave = (preferences: {
    necessary: boolean;
    analytics: boolean;
    marketing: boolean;
  }) => {
    const prefs = {
      ...preferences,
      timestamp: Date.now()
    };
    localStorage.setItem('vitafrukt-cookie-consent', JSON.stringify(prefs));
    setShowCookieSettings(false);
  };
  return <>
      <footer className="bg-vita-green-deep text-vita-cream py-12 md:py-16" data-id="element-130">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
          {/* Main Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8" data-id="element-132">
            {/* Column 1: Brand */}
            <div className="sm:col-span-2 lg:col-span-1" data-id="element-133">
              <Link to="/" className="inline-block bg-white px-4 py-3 rounded-soft mb-4" data-id="element-134">
                <img src="https://cdn.magicpatterns.com/uploads/8Z3c4xx4DwUTrp4PhuSqRZ/3.svg" alt="VitaFrukt Logo" className="h-10 w-auto object-contain" data-id="element-135" />
              </Link>
              <p className="text-vita-green-light text-sm leading-relaxed mt-2" data-id="element-136">
                Gesundheit verstehen. Natürlich.
              </p>
            </div>

            {/* Column 2: Themen */}
            <div data-id="element-137">
              <h3 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-4" data-id="element-138">
                Themen
              </h3>
              <ul className="space-y-2.5" data-id="element-139">
                <li data-id="element-140">
                  <Link to="/artikel" className="text-vita-green-light hover:text-white transition-colors text-sm" data-id="element-141">
                    Alle Artikel
                  </Link>
                </li>
                <li data-id="element-142">
                  <Link to="/#kategorien" className="text-vita-green-light hover:text-white transition-colors text-sm" data-id="element-143">
                    Kategorien
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Rechtliches */}
            <div data-id="element-144">
              <h3 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-4" data-id="element-145">
                Rechtliches
              </h3>
              <ul className="space-y-2.5" data-id="element-146">
                <li data-id="element-147">
                  <Link to="/impressum" className="text-vita-green-light hover:text-white transition-colors text-sm" data-id="element-148">
                    Impressum
                  </Link>
                </li>
                <li data-id="element-149">
                  <Link to="/datenschutz" className="text-vita-green-light hover:text-white transition-colors text-sm" data-id="element-150">
                    Datenschutzerklärung
                  </Link>
                </li>
                <li data-id="element-151">
                  <Link to="/haftungsausschluss" className="text-vita-green-light hover:text-white transition-colors text-sm" data-id="element-152">
                    Medizinischer Hinweis
                  </Link>
                </li>
                <li data-id="element-153">
                  <button onClick={() => setShowCookieSettings(true)} className="text-vita-green-light hover:text-white transition-colors text-sm text-left" data-id="element-154">
                    Cookie-Einstellungen
                  </button>
                </li>
              </ul>
            </div>

            {/* Column 4: Kontakt */}
            <div data-id="element-155">
              <h3 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-4" data-id="element-156">
                Kontakt
              </h3>
              <ul className="space-y-2.5" data-id="element-157">
                <li data-id="element-158">
                  <Link to="/kontakt" className="text-vita-green-light hover:text-white transition-colors text-sm" data-id="element-159">
                    Kontaktformular
                  </Link>
                </li>
                <li data-id="element-160">
                  <a href="mailto:info@vitafrukt.de" className="text-vita-green-light hover:text-white transition-colors text-sm" data-id="element-161">
                    info@vitafrukt.de
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 pt-8 border-t border-vita-green-medium flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-162">
            <p className="text-vita-green-sage text-sm" data-id="element-163">
              © {currentYear} VitaFrukt. Alle Rechte vorbehalten.
            </p>
            <p className="text-vita-green-sage text-xs max-w-md text-center md:text-right leading-relaxed" data-id="element-164">
              Die Inhalte dieser Website dienen ausschließlich
              Informationszwecken und ersetzen keine medizinische Beratung.
            </p>
          </div>
        </div>
      </footer>

      <CookieSettings isOpen={showCookieSettings} onClose={() => setShowCookieSettings(false)} onSave={handleCookieSave} data-id="element-165" />
    </>;
}